import React from "react";
import { DayPlanProvider } from "./DayPlanProvider";
import { ControlPanel } from "./components/ControlPanel/ControlPanel";
import { PlanList } from "./components/PlanList/PlanList";
import { CategoryButtons } from "./components/CategoryButtons/CategoryButtons";

interface DayPlanFullscreenProps {
  offerId: string;
  offerDays: any[];
  currentDayIndex: number;
  onUpdateData: (data: { offerDays: any[] }) => void;
  onNext: () => void;
  onPrev: () => void;
  checkInDate?: string;
  checkOutDate?: string;
  numberOfGuests?: number;
}

const DayPlanFullscreen: React.FC<DayPlanFullscreenProps> = ({
  offerId,
  offerDays,
  currentDayIndex,
  onUpdateData,
  onNext,
  onPrev,
  checkInDate,
  checkOutDate,
  numberOfGuests,
}) => {
  return (
    <DayPlanProvider
      offerId={offerId}
      initialOfferDays={offerDays}
      initialDayIndex={currentDayIndex}
      numberOfGuests={numberOfGuests}
      onOfferDaysChanged={(days) => onUpdateData({ offerDays: days })}
    >
      <div className="min-h-screen bg-neutral-50 w-full">
        {/* Layout na pełną szerokość */}
        <div className="w-full px-4 py-6">
          {/* Control Panel */}
          <ControlPanel />

          {/* Main Content */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200">
            {/* Plan List */}
            <div className="p-6">
              <PlanList />
            </div>

            {/* Category Buttons */}
            <div className="px-6 pb-6">
              <CategoryButtons
                checkInDate={checkInDate}
                checkOutDate={checkOutDate}
              />
            </div>
          </div>

          {/* Actions */}
          <div className="flex justify-between py-4 bg-white border-t border-gray-200">
            <button onClick={onPrev} className="btn-secondary">
              Wstecz
            </button>
            <button onClick={onNext} className="btn-primary">
              Dalej - Podsumowanie
            </button>
          </div>
        </div>
      </div>
    </DayPlanProvider>
  );
};

export default DayPlanFullscreen;
